/**
 * Shown the first time pages are added to a book (design "popup-pages-multiple-4", variant B) :
 * the adviser explains in a speech bubble that an album goes by 4 pages, blank ones being added at
 * the making otherwise. Desktop, mobile and the app alike.
 *
 * It slides down from the top, and back up when it closes.
 *
 * "OK, compris", Escape, Enter or a click behind closes it ; Tab stays on the only button.
 * The callers keep the "first time only" rule (account notification "multiple-four").
 *
 *   this.popup(new common.popups.AddPagePopup());
 */
fx.ns("common.popups", class AddPagePopup extends fx.Component {

    constructor()
    {
        super();

        this._onKey = this._onKey.bind(this);
    }

    onReady()
    {
        super.onReady();

        this._overlay = this.node.querySelector(".fx-pages-modal");
        this._button = this.node.querySelector(".fx-pages-modal__btn");

        this.on("click", this.close, this._button);   // a tap on the touch builds
        this.on("click", this._onClickBehind, this._overlay);

        this._lastFocus = document.activeElement;

        // capture on window : runs before fx.keyboard, which listens there too
        window.addEventListener("keydown", this._onKey, true);

        this._button.focus();
    }

    close()
    {
        if (this._closed)
            return;

        this._closed = true;
        this._release();
        this.addClass("closing");
        this.delay(this._hidden, this._reducedMotion ? 0 : this.SLIDE_OUT);
        this.trigger("closed");
    }

    // the card slides back up, then goes
    _hidden()
    {
        this.hide(this.destroy.bind(this));
    }

    // ms the card takes to slide up when it closes, as in AddPagePopup.scss
    get SLIDE_OUT() { return 300; }

    get _reducedMotion()
    {
        return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    destroy()
    {
        this._release();
        super.destroy();
    }

    _release()
    {
        window.removeEventListener("keydown", this._onKey, true);

        if (this._lastFocus && this._lastFocus.focus && document.contains(this._lastFocus))
            this._lastFocus.focus();

        this._lastFocus = null;
    }

    _onClickBehind(e)
    {
        let target = e.target || (e.srcEvent && e.srcEvent.target);

        if (target === this._overlay)
            this.close();
    }

    _onKey(e)
    {
        if (e.key === "Escape" || e.key === "Enter")
        {
            e.preventDefault();
            e.stopPropagation();
            this.close();
        }
        else if (e.key === "Tab")
        {
            e.preventDefault();
            this._button.focus();
        }
    }

    render()
    {
        let asset = fx.get("assets").personAdvice,
            photo = asset instanceof fx.Asset ? asset.content : asset;

        return  '<div class="fx-pages-modal">' +
                    '<div class="fx-pages-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="fxPagesModalTitle" aria-describedby="fxPagesModalText">' +
                        '<div class="fx-pages-modal__row">' +
                            '<img class="fx-pages-modal__avatar" src="' + photo + '" alt="' + fx.text("Conseillère Flexilivre") + '" width="128" height="128" draggable="false">' +
                            '<div class="fx-pages-modal__bubble">' +
                                '<h2 class="fx-pages-modal__title" id="fxPagesModalTitle">' + fx.text("Psst ! $ pages", "<span>+2</span>") + '</h2>' +
                                '<p class="fx-pages-modal__text" id="fxPagesModalText">' + fx.text("Un album se fait par <strong>4 pages</strong>. Sinon, on complète avec des pages blanches lors de la fabrication.") + '</p>' +
                            '</div>' +
                        '</div>' +
                        '<button type="button" class="fx-pages-modal__btn" data-testid="add-page-popup-ok">' + fx.text("OK, compris") + '</button>' +
                    '</div>' +
                '</div>';
    }

});
